import {bymoTemplateMetadataFactoryCreate} from "../../../doppe-sdk";
import {WixMediaResource} from '@wix/devzai-common-wix';

export const BymoTemplateActionInLandingPagePreviewPageType = {
    MainPage: 'mainPage',
    InnerPage: 'innerPage',
} as const;

export type BymoTemplateActionInLandingPagePreviewPageType = typeof BymoTemplateActionInLandingPagePreviewPageType[keyof typeof BymoTemplateActionInLandingPagePreviewPageType];

export namespace BymoTemplateActionInLandingPagePreview {

    export interface TemplateProps {
        /**
         * The type of page being previewed. 
         * - 'mainPage': Shows circle profile image skeleton (default)
         * - 'innerPage': Shows rectangle cover image skeleton
         */
        previewPageType?: BymoTemplateActionInLandingPagePreviewPageType;
        
        /**
         * Cover media for inner page preview.
         * If provided, the cover image will be rendered instead of the skeleton.
         */
        innerPageCoverMedia?: WixMediaResource[] | null;
    }
}

const initialValues: BymoTemplateActionInLandingPagePreview.TemplateProps = {
    previewPageType: BymoTemplateActionInLandingPagePreviewPageType.MainPage,
    innerPageCoverMedia: null,
};

export const BymoTemplateActionInLandingPagePreviewMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateActionInLandingPagePreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {},
    features: [
        'hasActions', 'hasActionButton' , 'hasProfileContent' ,'hasCustomTextualContent'
    ]
})